export const ENV_PRODUCTION = "production";
export const ENV_STAGING = "staging";
export const ENV_LOCAL = "local";
